import {AbstractDrawMode} from "../abstract-draw-mode";
import * as CommonSelectors from '@mapbox/mapbox-gl-draw/src/lib/common_selectors';

export class EditorTransformPoint extends AbstractDrawMode {
  static selectionAllowed: boolean = true;
  static selectionRequired: boolean = true;

  toDisplayFeatures(state, geojson, display) {
    // display(geojson);
    display(state.aim);
  }

  setup(opts) {
    if (opts.geometries.length === 0) {
      //todo: change mode to select? shouldn't get into select transform without selection
      console.error("Cannot select transform without selection");
      return;
    }

    let featureId = opts.geometries[0].geometryId;
    const feature = JSON.parse(JSON.stringify(opts.geometries[0].geometry));

    return {
      ...super.setup(opts),
      ...this.setupAutoAIM(
        {
          originalLocation: feature.geometry.coordinates,
          parentFeatureId: featureId,
        }
      ),
      dirty: false,
      featureId,
      feature,
      layerGeometry: opts.geometries[0],
      originalFeature: JSON.parse(JSON.stringify(feature)), //todo: deep clone geometry
      canDragMove: false,
      dragMoving: false,
      dragMoveLocation: undefined,
      dragFeatureTarget: undefined,
    };
  }

  contextMenu(state: any): any[] {
    let options = [];

    if (state.dirty) {
      options.push({
        label: 'Reset',
        icon: '/icons/toolbox/reset.svg',
        command: () => {
          this.reset(state);
        }
      });
      options.push({
        label: 'Finalize',
        icon: '/icons/toolbox/check.svg',
        command: () => this.save(state, true)
      });
    }

    return options;
  }

  onKeyUp(state, e) {
    if (CommonSelectors.isEscapeKey(e)) {
      this.reset(state);
    } else if (CommonSelectors.isEnterKey(e)) {
      this.save(state)
    }
  }

  reset(state: any): void {
    state.feature.geometry.coordinates = JSON.parse(JSON.stringify(state.layerGeometry.geometry.geometry.coordinates));
    state.originalFeature.geometry.coordinates = state.feature.geometry.coordinates;
    this.autoAIM(state, {lngLat: {lng: 0, lat: 0}}, state.feature.geometry.coordinates)
    state.dirty = false;
    this.tick();
  }

  save(state: any, silent: boolean = false): void {
    if (!state.dirty) {
      return;
    }
    if (silent) {
      this.persist(state);
      return;
    }
    this.attemptUpdateLayerGeometry(
      state.layerGeometry,
      state.feature,
      () => this.persist(state),
      () => {
      }
    )
  }

  onMouseDown(state, e) {
    if (!this.isAIM(e)) {
      return false;
    }

    state.dragFeatureTarget = 0;

    this.startDragging(state, e);
  }

  onDrag(state, e) {

    if (state.canDragMove) {
      let snapPoint = this.controller().snapUtility.getSnapPoint(e);

      this.autoAIM(state, e, snapPoint.point);
    }
  }

  onTouchStart(state, e) {
    this.onMouseDown(state, e)
  }

  onTouchEnd(state, e) {
    this.onMouseUp(state, e)
  }


  onStop(state) {
    this.save(state);
  }

  startDragging(state, e) {
    this.map.dragPan.disable();
    state.canDragMove = true;
    state.dragMoveLocation = [e.lngLat.lng, e.lngLat.lat];
  }

  stopDragging(state) {
    this.map.dragPan.enable();
    state.dragMoving = false;
    state.canDragMove = false;
    state.dragMoveLocation = undefined;
    state.dragFeatureTarget = undefined;
  }

  onMouseUp(state, e) {
    if (!state.canDragMove) {
      return;
    }
    let snapPoint = this.controller().snapUtility.getSnapPoint(e);

    this.autoAIM(state, e, snapPoint.point);

    state.feature.geometry.coordinates = JSON.parse(JSON.stringify(snapPoint.point));
    state.originalFeature = {type: "Feature", geometry: {...state.feature.geometry}};

    this.stopDragging(state);
    state.dirty = true;
    this.tick();
  }

  persist(state: any): void {
    this.updateLayerGeometry(state.layerGeometry, state.feature)
    state.layerGeometry.geometry.geometry.coordinates = state.feature.geometry.coordinates;
    state.dirty = false;
    this.tick();
  }

  _inheritedMethods(): string[] {
    return [
      ...super._inheritedMethods(),
      'startDragging',
      'stopDragging',
      'reset',
      'save',
      'persist'
    ];
  }
}
